import { env } from './env'

export const STORAGE_KEYS = {
  token: 'baxtr.token',
  user: 'baxtr.user',
} as const

export const API_BASE_URL = env.current.VITE_API_BASE_URL
export const APP_NAME = env.current.VITE_APP_NAME
